var map = {
	"./ch_CH.svg": 5129,
	"./de_DE.svg": 2749,
	"./el_EL.svg": 5096,
	"./en_GB.svg": 5896,
	"./es_ES.svg": 2831,
	"./fr_FR.svg": 8744,
	"./it_IT.svg": 7675,
	"./logo.svg": 2835,
	"./merchandising_default_image.svg": 7745,
	"./nl_BE.svg": 6875,
	"./nl_NL.svg": 2916,
	"./pt_PT.svg": 1924,
	"./user-profile.svg": 4692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;